import { BILLING_CYCLE, PlanModelInfo, planTypes } from '@/common/constants';
import { getCartInfo } from '@/common/service/default-mapper'
import { EVENT_SERVICES_KEYS } from './constants'

export default function (planMapJSON) {
  if (!planMapJSON || !planMapJSON.pso) return []

  return EVENT_SERVICES_KEYS.map((key) => {
    const plan = planMapJSON.pso[key]
    return {
      ...plan,
      type: planTypes.EVENT_SERVICES,
      category: plan.category,
      parent_category: plan.parent_category,
      participants: plan.participants,
      plan_code: plan.onetime_plancode,
      plan_type: plan.onetime_plantype,
      amount: plan.onetime_amount,
      billing_cycle: BILLING_CYCLE.ONE_TIME,
      cartInfo: getCartInfo(),
      supportCoupon: false,
      dependBasePlanTypeList: [planTypes.WEBINAR],
      typeNameKey: 'billing.event_services.title',
      planNameKey: 'billing.event_services.title',
      planModel: PlanModelInfo.usage
    }
  })
}
